export const SITE = {
  name: "Krithish Scientific Company",
  shortName: "KSC",
  tagline: "Mfrs. of Krithish Scientific, Industrial & Lab Equipments",
  gstin: "GSTIN: 33AINPR0146B1ZM",
  phoneDisplay: "+91 88413 24391",
  phone2Display: "+91 86107 09048",
  phoneHref: "tel:+918841324391",
  phone2Href: "tel:+918610709048",
  email: "krithishscientific.co@gmail.com",
  email2: "ksc.labinstruments@yahoo.com",
  whatsapp:
    "https://wa.me/918841324391?text=Hello%20Krithish%20Scientific%20Company%2C%20I%27d%20like%20to%20enquire%20about%20your%20equipment.",
  addressLines: [
    "No. 15, Pugazhendhi Street Extension,",
    "Sanjay Gandhi Colony, Choolai Pallam,",
    "M.G.R. Nagar, Chennai – 600 078, Tamil Nadu",
    "GSTIN: 33AINPR0146B1ZM",
  ],
  mapEmbed:
    "https://maps.google.com/maps?q=Pugazhendhi%20Street%20Extension%2C%20Sanjay%20Gandhi%20Colony%2C%20M.G.R.%20Nagar%2C%20Chennai%20600078&t=&z=14&ie=UTF8&iwloc=&output=embed",
  hours: "[Mon – Sat, 9:30 AM – 6:30 PM]",
};

export const PRODUCT_LINKS = [
  { slug: "sterilization", name: "Sterilization & Autoclaves" },
  { slug: "ovens-dryers", name: "Ovens & Tray Dryers" },
  { slug: "incubators-shakers", name: "Incubators & Shakers" },
  { slug: "baths", name: "Water, Oil & Low-Temp Baths" },
  { slug: "chambers", name: "Humidity & Environmental Chambers" },
  { slug: "freezers-mortuary", name: "Deep Freezers & Mortuary" },
  { slug: "furnaces", name: "Furnaces & Incinerators" },
  { slug: "clean-air", name: "Clean Air & Safety" },
  { slug: "heating-stirring", name: "Heating & Stirring" },
  { slug: "instruments", name: "Balances & Instruments" },
  { slug: "lab-setup", name: "Lab Setup & Utilities" },
  { slug: "service", name: "Repair & Service" },
];

export const inputCls =
  "w-full rounded-lg border border-slate-300 bg-white px-3.5 py-2.5 text-sm text-slate-900 placeholder:text-slate-400 outline-none transition focus:border-sky-500 focus:ring-2 focus:ring-sky-100";

export const labelCls = "mb-1.5 block text-xs font-semibold uppercase tracking-wider text-slate-600";

export const btnPrimary =
  "inline-flex items-center justify-center gap-2 rounded-lg bg-safety px-5 py-3 text-sm font-semibold text-white transition hover:bg-safety-dark disabled:cursor-not-allowed disabled:opacity-60";

export const btnOutline =
  "inline-flex items-center justify-center gap-2 rounded-lg border border-slate-300 bg-white px-5 py-3 text-sm font-semibold text-slate-800 transition hover:border-safety hover:text-safety disabled:opacity-60";

export const btnGhostLight =
  "inline-flex items-center justify-center gap-2 rounded-lg border border-white/40 bg-transparent px-5 py-3 text-sm font-semibold text-white transition hover:bg-white hover:text-navy";
